import serviceProviderApi from '../services/api/serviceProviderApi';
import officerApi from '../services/api/officerApi';
import officerInviteApi from '../services/api/officerInviteApi';
import { setAlert } from './alerts';
import { formatResponseErrorsForFormik } from '../services/http/errors';

export const SERVICE_PROVIDERS_REFRESHED =
    'SETTINGS/SERVICE_PROVIDERS_REFRESHED';
export const SERVICE_PROVIDER_REFRESHED = 'SETTINGS/SERVICE_PROVIDER_REFRESHED';
export const OFFICERS_REFRESHED = 'SETTINGS/OFFICERS_REFRESHED';
export const OFFICER_INVITES_REFRESHED = 'SETTINGS/OFFICER_INVITES_REFRESHED';
export const RESET = 'SETTINGS/RESET';

export const serviceProvidersRefreshed = (serviceProviders) => ({
    type: SERVICE_PROVIDERS_REFRESHED,
    serviceProviders,
});

export const serviceProviderRefreshed = (serviceProvider) => ({
    type: SERVICE_PROVIDER_REFRESHED,
    serviceProvider,
});

export const officersRefreshed = (officers) => ({
    type: OFFICERS_REFRESHED,
    officers,
});

export const officerInvitesRefreshed = (officerInvites) => ({
    type: OFFICER_INVITES_REFRESHED,
    officerInvites,
});

export const reset = () => ({
    type: RESET,
});

export const getAllServiceProviders = () => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await serviceProviderApi.getAll();
        dispatch(serviceProvidersRefreshed(data));
    } catch ({ response }) {
        dispatch(setAlert('Unable to fetch service providers.', 'error'));
    }
};

export const getServiceProvider = (id) => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await serviceProviderApi.getOne(id);
        dispatch(serviceProviderRefreshed(data));
    } catch ({ response }) {
        dispatch(setAlert('Unable to fetch service provider.', 'error'));
    }
};

export const getServiceProviderOfficers = (id) => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await officerApi.getAllByServiceProvider(id);
        dispatch(officersRefreshed(data));
    } catch ({ response }) {
        dispatch(
            setAlert('Unable to fetch service provider officers.', 'error')
        );
    }
};

export const getServiceProviderOfficerInvites = (id) => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await officerInviteApi.getAllByServiceProvider(id);
        dispatch(officerInvitesRefreshed(data));
    } catch ({ response }) {
        dispatch(
            setAlert(
                'Unable to fetch service provider officer invites.',
                'error'
            )
        );
    }
};

export const updateServiceProvider =
    (values, { setSubmitting, setErrors, resetForm }, onSuccess) =>
    async (dispatch) => {
        try {
            const {
                data: { data },
            } = await serviceProviderApi.update(values.id, values);
            setSubmitting(false);
            resetForm();
            dispatch(getServiceProvider(values.id));
            dispatch(
                setAlert(
                    'Service provider updated.',
                    'success',
                    false,
                    'service-provider'
                )
            );
            onSuccess();
        } catch ({ response }) {
            setSubmitting(false);
            const formattedErrors = formatResponseErrorsForFormik(
                response.data.errors
            );
            setErrors(formattedErrors);
        }
    };

export const onMarkAsDeactivated = (deactivated, setFieldValue) => {
    setFieldValue('deactivated', deactivated);
};
